<div #mainDiv_ll_build_form>
  <div *ngIf="bundle.showPanel && bundle.questionList.length > 0" class="question-list">
    <div *ngFor="let q of bundle.questionList; let i = index" class="question-item">

      <!-- QUESTIONNAME Row -->
      <div class="question-name-row">
        <div class="question-name-container">
          <span *ngIf="!isEditing(q.STUDYQUESTIONID)" class="question-display">
            {{ q.QUESTIONNAME }}
          </span>
          <textarea *ngIf="isEditing(q.STUDYQUESTIONID)"
                    [(ngModel)]="q.QUESTIONNAME"
                    class="question-textarea"
                    rows="1">
          </textarea>
        </div>

        <div class="action-buttons">
          <span *ngIf="!isEditing(q.STUDYQUESTIONID)"
                class="wordBtn"
                (click)="startEditing(q.STUDYQUESTIONID)">
            Edit
          </span>
          <span *ngIf="isEditing(q.STUDYQUESTIONID)"
                class="wordBtn"
                (click)="saveQuestion(q.STUDYQUESTIONID)">
            Save
          </span>
        </div>
      </div>

      <!-- Input Type + MLP Choices in SAME ROW -->
      <div class="input-type-row">
        <label class="input-label-bold">Input Type:</label>

        <!-- Display Mode -->
        <span *ngIf="!isEditing(q.STUDYQUESTIONID)" class="input-label">
          {{ getInputTypeLabel(getQuestionValue('QUESTIONINPUTTYPE', q.STUDYQUESTIONID)) }}
        </span>

        <!-- Edit Mode -->
        <select *ngIf="isEditing(q.STUDYQUESTIONID)"
                [ngModel]="getQuestionValue('QUESTIONINPUTTYPE', q.STUDYQUESTIONID)"
                (ngModelChange)="onChanged('QUESTIONINPUTTYPE', $event, q.STUDYQUESTIONID)"
                class="form-input form-select">
          <option value="" disabled>Select input type...</option>
          <option *ngFor="let inputType of questionInputTypeList"
                  [value]="inputType.value">
            {{ inputType.label }}
          </option>
        </select>

        <!-- MLP Choices - Same row as Input Type with "Change" button -->
        <div *ngIf="getQuestionValue('QUESTIONINPUTTYPE', q.STUDYQUESTIONID) === 'MLP'"
             class="mlp-choices-container">

          <div class="mlp-textarea-wrapper">

            <!-- Display Mode -->
            <span *ngIf="!isEditing(q.STUDYQUESTIONID)" class="input-label">
              {{ q.MLPCHOICES }}
            </span>

            <textarea *ngIf="isEditing(q.STUDYQUESTIONID)"
                      [(ngModel)]="q.MLPCHOICES"
                      (keyup)="onMLPChoicesChange(q.MLPCHOICES, q.STUDYQUESTIONID)"
                      class="mlp-choices-textarea"
                      rows="1"
                      placeholder="Enter comma-separated choices...">
            </textarea>

          </div>
        </div>


      </div>



      <!-- questionRequired_default + ShowLogic in SAME ROW -->
      <div class="input-type-row">
        <label class="input-label-bold">Required:</label>

        <!-- Display Mode -->
        <span *ngIf="!isEditing(q.STUDYQUESTIONID)" class="input-label">
          {{ getRequiredLabel(getQuestionValue('QUESTIONREQUIRED_DEFAULT', q.STUDYQUESTIONID)) }}
        </span>

        <!-- Edit Mode -->
        <select *ngIf="isEditing(q.STUDYQUESTIONID)"
                [ngModel]="getQuestionValue('QUESTIONREQUIRED_DEFAULT', q.STUDYQUESTIONID)"
                (ngModelChange)="onChanged('QUESTIONREQUIRED_DEFAULT', $event, q.STUDYQUESTIONID)"
                class="form-input form-select">
          <option value="" disabled>Select input type...</option>
          <option *ngFor="let req of questionRequiredList"
                  [value]="req.value">
            {{ req.label }}
          </option>
        </select>

        <!-- EQUATION_SHOWHIDE - Same row as QUESTIONREQUIRED_DEFAULT -->
        <div *ngIf="getQuestionValue('QUESTIONREQUIRED_DEFAULT', q.STUDYQUESTIONID) === 'C'"
             class="mlp-choices-container">

          <div class="mlp-textarea-wrapper">

            <!-- Display Mode -->
            <span *ngIf="!isEditing(q.STUDYQUESTIONID)" class="input-label">
              {{ q.EQUATION_SHOWHIDE }}
            </span>
          </div>
        </div>


      </div>

      <!-- Divider -->
      <div class="question-divider" [style.width.px]="bundle.panelW"></div>

    </div>
  </div>
</div>
